import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { db } from "../firebase"; // Firebase setup
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
} from "firebase/firestore";

const ClientsTable = () => {
  const [clients, setClients] = useState([]);
  const [clientName, setClientName] = useState("");
  const [dateSigned, setDateSigned] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [services, setServices] = useState("");
  const [paymentType, setPaymentType] = useState("One Time");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [clientStatus, setClientStatus] = useState("Ongoing");

  const clientsCollectionRef = collection(db, "clients");

  useEffect(() => {
    const fetchClients = async () => {
      const data = await getDocs(clientsCollectionRef);
      setClients(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    fetchClients();
  }, []);

  const addClient = async (e) => {
    e.preventDefault();
    if (!clientName || !services || !paymentAmount) {
      alert("Please fill in all required fields.");
      return;
    }

    const newClient = {
      clientName,
      dateSigned,
      services,
      paymentType,
      paymentAmount,
      clientStatus,
    };

    try {
      const docRef = await addDoc(clientsCollectionRef, newClient);
      setClients([...clients, { ...newClient, id: docRef.id }]);
      clearForm();
    } catch (error) {
      console.error("Error adding client:", error);
    }
  };

  const deleteClient = async (clientId) => {
    try {
      await deleteDoc(doc(db, "clients", clientId));
      setClients(clients.filter((client) => client.id !== clientId));
    } catch (error) {
      console.error("Error deleting client:", error);
    }
  };

  const clearForm = () => {
    setClientName("");
    setServices("");
    setPaymentAmount("");
  };

  return (
    <Container>
      <h2>Clients Table</h2>
      <TableWrapper>
        <table>
          <thead>
            <tr>
              <th>Client Name</th>
              <th>Date Signed</th>
              <th>Services</th>
              <th>Payment Type</th>
              <th>Payment Amount</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {clients.map((client) => (
              <tr key={client.id}>
                <td>{client.clientName}</td>
                <td>{client.dateSigned}</td>
                <td>{client.services}</td>
                <td>{client.paymentType}</td>
                <td>${client.paymentAmount}</td>
                <td>{client.clientStatus}</td>
                <td>
                  <DeleteButton onClick={() => deleteClient(client.id)}>
                    Delete
                  </DeleteButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableWrapper>
      <AddClientForm onSubmit={addClient}>
        <Input
          type="text"
          placeholder="Client Name"
          value={clientName}
          onChange={(e) => setClientName(e.target.value)}
          required
        />
        <Input
          type="date"
          value={dateSigned}
          onChange={(e) => setDateSigned(e.target.value)}
        />
        <Input
          type="text"
          placeholder="Services"
          value={services}
          onChange={(e) => setServices(e.target.value)}
          required
        />
        <Select
          value={paymentType}
          onChange={(e) => setPaymentType(e.target.value)}
        >
          <option value="One Time">One Time</option>
          <option value="Recurring">Recurring</option>
        </Select>
        <Input
          type="number"
          placeholder="Payment Amount"
          value={paymentAmount}
          onChange={(e) => setPaymentAmount(e.target.value)}
          required
        />
        <Select
          value={clientStatus}
          onChange={(e) => setClientStatus(e.target.value)}
        >
          <option value="Ongoing">Ongoing</option>
          <option value="Finished">Finished</option>
        </Select>
        <AddButton type="submit">Add Client</AddButton>
      </AddClientForm>
    </Container>
  );
};

const Container = styled.div`
  width: 47%;
  margin: 20px auto;
  padding: 20px;
  background-color: #171c29;
  border-radius: 20px;
  color: white;

  h2 {
    color: #70a8e7;
    font-weight: 300;
    text-align: center;
    margin-bottom: 20px;
  }
  @media (max-width: 1932px) {
    width: 100%;
  }
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: 800px;

    th,
    td {
      padding: 10px;
      text-align: left;
      border: 1px solid #1c2130;

      button {
        border: none;
        background-color: #20273a;
        color: white;
        padding: 10px;
        border-radius: 10px;
        cursor: pointer;
      }
    }

    th {
      background-color: #20273a;
      color: #70a8e7;
    }
  }
`;

const AddClientForm = styled.form`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  margin-top: 20px;
`;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #1c2130;
  border-radius: 10px;
  background-color: #20273a;
  color: white;
  outline: none;
`;

const Select = styled.select`
  padding: 10px;
  border: 1px solid #1c2130;
  border-radius: 10px;
  background-color: #20273a;
  color: white;
  outline: none;
`;

const AddButton = styled.button`
  padding: 10px;
  background: #18812a;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: #145a20;
  }
`;

const DeleteButton = styled.button`
  background: #d9534f;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background: #c9302c;
  }
`;

export default ClientsTable;
